import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { t } from "i18next";
import { generateMessage } from "./firebaseMessage";
import api from "./api";

let response = {
  status: null,
  data: null,
  message: "",
};

export const fetchMastersListAsync = async (uid) =>
  await api
    .get(`/master?createdBy=${uid}`)
    .then((res) => res.data)
    .catch((err) => err);

export const createMastersListAsync = async (payload) =>
  await api
    .post(`/master`, payload)
    .then((res) => res.data)
    .catch((err) => err);

export const updateMastersListAsync = async (payload, id) =>
  await api
    .put(`/master/${id}`, payload)
    .then((res) => res.data)
    .catch((err) => err);

export const fetchMastersListDetailAsync = async (id) =>
  await api
    .get(`/master/${id}`)
    .then((res) => res.data)
    .catch((err) => err);

export const deleteMastersListAsync = async (id) =>
  api
    .delete(`/master/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
